import { Program } from '@/types/models';

export function mergeRerankedScores(
  base: Program[],
  scores: { id: string | number; score: number }[],
): Program[] {
  if (!Array.isArray(base) || base.length === 0 || !Array.isArray(scores) || scores.length === 0)
    return base;

  const idToScore = new Map<string | number, number>();
  for (const s of scores) idToScore.set(s.id, s.score);

  const withIndex = base.map((p, idx) => ({ p, idx, score: idToScore.get(p.id) }));
  withIndex.sort((a, b) => {
    const aScore = typeof a.score === 'number' ? a.score : -1;
    const bScore = typeof b.score === 'number' ? b.score : -1;
    if (aScore !== bScore) return bScore - aScore;
    return a.idx - b.idx;
  });

  return withIndex.map(x => ({ ...x.p, meta: { ...(x.p.meta || {}), rerank_score: x.score } }));
}
